/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Deep_TitleInputs */

const en_to_xml_deep_title = /** @type {(inputs: To_Xml_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element names, and the two cases that would otherwise produce invalid XML`)
};

const ko_to_xml_deep_title = /** @type {(inputs: To_Xml_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요소 이름, 그리고 그대로 두면 유효하지 않은 XML이 되는 두 경우`)
};

const ja_to_xml_deep_title = /** @type {(inputs: To_Xml_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要素名、そしてそのままなら妥当でない XML になる 2 つのケース`)
};

/**
* | output |
* | --- |
* | "Element names, and the two cases that would otherwise produce invalid XML" |
*
* @param {To_Xml_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_deep_title = /** @type {((inputs?: To_Xml_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_deep_title(inputs)
	if (locale === "ko") return ko_to_xml_deep_title(inputs)
	return ja_to_xml_deep_title(inputs)
});